import { Button, Card, Heading } from '@appd/uik';
import { capitalizeFirstLetter } from '../../../utils';
import { FilterPropertiesPanelContent, WidgetPropertiesPanelContent } from '../../components/widget/components';
import {
  ComponentType,
  ComponentTypeOption,
  VisualizationTypeOption,
  WidgetProps,
} from '../../components/widget/models';
import { ExpressionJson } from '../../models';

interface DashifyPropertiesPanelProps {
  selectedComponentType: ComponentTypeOption;
  propsJSON: any;
  setProps: ([]: Record<string, unknown>) => void;
  isInspectMode?: boolean;
  expressions?: Record<string, ExpressionJson>;
  queryResult?: Record<string, unknown>;
}

export const DashifyPropertiesPanel: React.FC<DashifyPropertiesPanelProps> = ({
  selectedComponentType,
  propsJSON,
  setProps,
  isInspectMode = false,
  expressions = {},
  queryResult,
}) => {
  return (
    <div data-testid="dashify-properties-panel" className={isInspectMode ? 'w-0' : 'w-[400px]'}>
      <Card.Container
        style={{
          height: 'calc(100% - 48px)',
          borderRadius: 0,
          boxShadow: 'none',
          overflow: 'auto',
          borderLeft: '1px solid #e5e7eb',
        }}
      >
        <div className="flex flex-row items-center justify-between">
          <Heading size="PRIMARY">{`${capitalizeFirstLetter(selectedComponentType)} properties`}</Heading>
        </div>

        {/* Filter Properties */}
        {selectedComponentType === ComponentType.FILTER && (
          <FilterPropertiesPanelContent
            widget={propsJSON as WidgetProps}
            updateWidget={(updatedProps: Record<string, any>) => setProps(updatedProps)}
            expressions={expressions}
            queryResult={queryResult}
          />
        )}

        {/* Widget Properties */}
        {selectedComponentType === ComponentType.WIDGET && (
          <WidgetPropertiesPanelContent
            widget={propsJSON as WidgetProps}
            updateType={(newType: VisualizationTypeOption) => console.log('new visualization type', newType)}
            updateWidget={(updatedProps: Record<string, any>) => setProps(updatedProps)}
            expressions={expressions}
          />
        )}
      </Card.Container>
    </div>
  );
};
